import React from 'react';
import {useState} from "react";

declare const RECHARGE_PRODUCT_DATA: any;

interface PurchaseFrequencyDropdownProps{
    id : number;
    offerOneTimePurchase: boolean;
    setFrequencyState: Function;

}
const PurchaseFrequencyDropdown = (props: PurchaseFrequencyDropdownProps) => {
    const rechargefrequencies = RECHARGE_PRODUCT_DATA.find((x:any) => x.id === props.id).subscriptions[0].order_interval_frequency_options
    const interval_unit = RECHARGE_PRODUCT_DATA.find((x:any) => x.id === props.id).subscriptions[0].order_interval_unit
    const firstOption = props.offerOneTimePurchase  ? 0 :rechargefrequencies[0];
    const [selectedOption, setSelectedOption] = useState(firstOption);
    props.setFrequencyState(selectedOption)
    const handleDropdownSelection = (e : any) => {
        setSelectedOption(e.target.value)
        props.setFrequencyState(e.target.value)
        
    }
    return(
        <div className="select-wrapper">
            <select className="purchase-frequency-dropdown" onChange={handleDropdownSelection}>
                {props.offerOneTimePurchase  &&
                    <option label={"One-time purchase"} value={0}>One-time purchase</option>

                }
                {
                rechargefrequencies.map((frequency:number)=>
                    <option label={"Deliver every " + frequency + "-" + interval_unit + "s"} value={frequency}>{"Deliver every " + frequency + "-"  + interval_unit + "s"}</option>
                )
                }
            </select>
            <div className="select-arrow">▼</div>
        </div>
    )
}

export default PurchaseFrequencyDropdown;